import { ChainConfig, ChainsFromConfig } from '#/config/configType';

import berachainIcon from './berachain.svg';
import chainArbitrumIcon from './chainArbitrum.png';
import chainAvalancheIcon from './chainAvalanche.png';
import chainBaseIcon from './chainBase.png';
import chainBnbIcon from './chainBnb.svg';
import chainEthereumIcon from './chainEthereum.svg';
import chainMantleIcon from './chainMantle.png';
import chainOptimismIcon from './chainOptimism.png';
import chainPolygonIcon from './chainPolygon.png';
import chainUnknownIcon from './chainUnknown.png';
import katanaChainIcon from './katanaChain.png';
import seiChainIcon from './seiChain.png';

export const getChainIcon = (chain: ChainConfig | ChainsFromConfig) => {
  if (chain === 'katanaChain') {
    return katanaChainIcon;
  }
  const chainName = (
    typeof chain === 'string' ? chain : chain.chainNetwork
  ).toLowerCase();
  return chainName.includes('katana')
    ? katanaChainIcon
    : chainName.includes('polygon')
    ? chainPolygonIcon
    : chainName.includes('ethereum')
    ? chainEthereumIcon
    : chainName.includes('avalanche')
    ? chainAvalancheIcon
    : chainName.includes('optimism')
    ? chainOptimismIcon
    : chainName.includes('arbitrum')
    ? chainArbitrumIcon
    : chainName.includes('bnb') || chainName.includes('bsc')
    ? chainBnbIcon
    : chainName.includes('bera')
    ? berachainIcon
    : chainName.includes('base')
    ? chainBaseIcon
    : chainName.includes('mantle')
    ? chainMantleIcon
    : chainName.includes('sei')
    ? seiChainIcon
    : chainUnknownIcon;
};
